module.exports = __webpack_public_path__ + "img/waiting.eef5a92c.png";